import {
  DEFAULT_ANCHOR_BY_TYPE,
  DEFAULT_THICKNESS,
  ElementState,
  ElementType,
  Fixture as FixtureElement,
  FixtureType,
} from '@ritabygglov/core';
import { fixtureRegistry } from '../fixtureRegistry';

export const createFixture = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string,
  fixtureType = FixtureType.WINDOW_PLAN,
  options: Partial<FixtureElement> = {}
): FixtureElement => {
  const { defaultWidth, defaultHeight } = fixtureRegistry[fixtureType];

  return {
    type: ElementType.Fixture,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    userVersion: {
      userId,
      version: 1,
    },
    fixtureType,
    width: defaultWidth,
    height: defaultHeight,
    text: '',
    showDimensions: false,
    thickness: DEFAULT_THICKNESS,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Fixture],
    mirroredX: false,
    mirroredY: false,
    ...options,
    x: initialX,
    y: initialY,
    id,
  };
};
